module.exports = __webpack_public_path__ + "img/sub15.ac49f9c3.jpg";